import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useCardContext } from 'contexts/CardContext'

/**
 * Custom hook to load card data from server
 * @returns {void}
 */
export const useCardData = () => {
    const { cardId } = useParams()
    const { loadCardFromServer, isTemporaryCard } = useCardContext()

    useEffect(() => {
        const loadFreshCardData = async () => {
            if (cardId && !isTemporaryCard(cardId)) {
                try {
                    await loadCardFromServer(cardId)
                } catch (error) {
                    console.error('Error loading fresh card data:', error)
                }
            }
        }

        loadFreshCardData()
    }, [cardId, isTemporaryCard, loadCardFromServer])
}

